<template>
  <v-dialog v-model="dialog" persistent max-width="400px">
    <template v-slot:activator="{ on }">
      <span v-on="on">
        <edit-icon-button v-if="isUpdate"></edit-icon-button>
        <add-button v-else>Add New</add-button>
      </span>
    </template>
    <dialog-card
      :loading="loading"
      :title="title"
      @close="dialog = false"
      @submit="submit()"
    >
      <v-row>
        <v-col cols="12" class="pb-0">
          <input-field
            label="Payment Method"
            v-model="form.name"
            rules="required"
          ></input-field>
        </v-col>
      </v-row>
    </dialog-card>
  </v-dialog>
</template>

<script>
import {getDate, initForm} from "@/assets/utils/common.utils";
import AddButton from "../ui/buttons/AddButton.vue";
import EditIconButton from "../ui/buttons/EditIconButton.vue";
import DialogCard from "../ui/DialogCard.vue";
import InputField from "../ui/form/InputField.vue";
import {addDoc, doc, getDocs, limit, query, updateDoc, where,} from "firebase/firestore";
import {colClientPaymentMethods, colPaymentMethods,} from "@/assets/utils/firebase.utils";

export default {
  props: {
    item: {
      type: Object,
      default: () => ({}),
    },
  },
  data() {
    return {
      dialog: false,
      loading: false,
      form: {
        name: "",
        color: "#22FF2B",
      },
    };
  },
  components: {
    AddButton,
    EditIconButton,
    DialogCard,
    InputField,
  },
  watch: {
    dialog(val) {
      if (val) {
        initForm(this.form, this.item);
      }
    },
  },
  computed: {
    isUpdate() {
      return this.item.id != undefined;
    },
    title() {
      return this.isUpdate ? "Edit Payment Method" : "Add Payment Method";
    },
    isClientPaymentMethods() {
      return this.$route.name == "client-payment-methods";
    },
  },
  methods: {
    async submit() {
      const vm = this;
      try {
        let name_lw = vm.form.name.trim().toLowerCase();
        let status = {
          ...vm.form,
          updated_by: vm.userEmail,
          name_lw,
          updated_at: getDate(),
        };
        let isCreditCard = name_lw.split(" ").join("") == "creditcard";
        // let isAuthNet = ""
        if (this.isClientPaymentMethods && isCreditCard) {
          vm.notifyError(
            "This payment method already exists. Please enter a unique payment method."
          );
          return;
        }
        vm.loading = true;

        let col = this.isClientPaymentMethods
          ? colClientPaymentMethods
          : colPaymentMethods;
        let q = query(col, where("name_lw", "==", name_lw), limit(1));
        let snap = (await getDocs(q)).docs;
        let id = vm.item.id;
        if (snap.length != 0 && id != snap[0].id) {
          vm.loading = false;
          vm.notifyError(
            "This payment method already exists. Please enter a unique payment method."
          );
          return;
        }
        if (id) {
          await updateDoc(doc(col, id), status);
          vm.notifySuccess("Payment Method has been updated successfully.");
        } else {
          await addDoc(col, {
            ...status,
            created_at: getDate(),
          });
          vm.notifySuccess("Payment Method has been created successfully.");
        }
        vm.form = { name: "" };
        vm.$emit("onUpdate");
        vm.loading = false;
        vm.dialog = false;
      } catch (error) {
        vm.handleError(error);
      }
    },
  },
};
</script>

<style></style>
